import "./Launcher.scss";
import { useState, useEffect } from "react";
import { useAuthStore } from "../store/auth";
import {
  GAME_DEFAULT_SLOTS,
  GAME_DEFAULT_VB
} from "../constants";
import { useLauncherStore } from "../store/launcher";
import IframeModal from "../components/IframeModal/IframeModal";
import HomeButton from "../components/HomeButton/HomeButton";
import FormLauncher from "../components/FormLauncher/FormLauncher";
import { StringIndex, Game, Slots, Vb, Config } from "../interfaces/interfaces";
import { useGameParamsStore } from "../store/gameParams";


interface Props {
  slots: Slots;
  vb: Vb;
  config: Config;
}

export default function Launcher({ slots, vb, config }: Props) {
  const { params: gameParams } = useGameParamsStore((state) => state);
  const [isProviderTest, setProviderTest] = useState(false);
  const [isBranchTest, setBranchTest] = useState(false);
  const token = useAuthStore((state) => state.token);
  const {
    gameType,
    config: configIframe,
    iFrameCompatibility,
    setIFrameCompatibility,
  } = useLauncherStore((state) => state);

  const [slotGamesSorted, setSlotGamesSorted] = useState<Game[]>(
    slots.games.sort((a, b) => a.name.localeCompare(b.name)) || []
  );
  const [videoBingoGamesSorted, setVideoBingoGamesSorted] = useState<Game[]>(
    vb.games.sort((a, b) => a.name.localeCompare(b.name)) || []
  );

  const getUrl = (configUrl: string) => {
    const url = new URL(configUrl);
    const baseUrl = `${url.protocol}//${url.host}/`;
    return baseUrl;
  }
  const [urlForBranch, setUrlForBranch] = useState(getUrl(config.game_url) + "games");

  const [params, setParams] = useState({
    branch: "master",
    name:
      gameType === "slot"
        ? slotGamesSorted[0].name
        : videoBingoGamesSorted[0].name,
    demo: false,
    device: "mobile",
    lang: "es",
    hideFullScreenHand: "true",
    cashierURL: "https://www.google.com/search?q=abc&num=3",
    homeURL: "https://www.google.com/search?q=abc&num=3",
    providerId: "zitro",
    providerOperatorId: "showroom",
    platform: "slot-cocos",
    baseUrl: getUrl(config.game_url),
    certification: "curacao",
    serviceName: "showroom",
  });

  const [isShowModal, setShowModal] = useState(false);
  const [gameURL, setGameURL] = useState("");
  const [operatorUrl, setOperatorUrl] = useState("");

  const [ishomeURLValid, setIshomeURLValid] = useState<boolean>(true);
  const [iscashierURLValid, setIscashierURLValid] = useState<boolean>(true);
  const [providerInputData, setProviderInputData] = useState<StringIndex>({});

  const showModal = () => {
    setShowModal(true);
  };

  const hideModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    setParams((prev) => {
      return {
        ...prev,
        name: gameType === "slot" ? GAME_DEFAULT_SLOTS : GAME_DEFAULT_VB,
      };
    });
  }, [gameType]);

  useEffect(() => {
    if (window.screen.width <= 1024) {
      setIFrameCompatibility(false);
    }
  }, [setIFrameCompatibility]);

  useEffect(() => {
    return () => {
      setSlotGamesSorted([]);
      setVideoBingoGamesSorted([]);
    };
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    let url;
    const encodeCashierURL = params.cashierURL.includes("%")
      ? params.cashierURL
      : `${encodeURIComponent(params.cashierURL)}`;
    const encodeHomeURL = params.homeURL.includes("%")
      ? params.homeURL
      : `${encodeURIComponent(params.homeURL)}`;

    if (isBranchTest) {
      let path, vbDevice;
      const platformPaths: { [key: string]: string } = {
        "slot-cocos": `${params.name}/index.html`,
        "slot-cocos-lgm": `${params.name}/index.html`,
        "slot-link": `index.html`,
        "slot-pw": `server/index.html`,
      };

      if (params.platform in platformPaths) {
        path = platformPaths[params.platform];
      } else if (params.platform === "vb") {
        vbDevice = params.device === "desktop" ? "web" : "mobile";
        path = `html5/rm-${vbDevice}/${params.name}/latest/index.html`;
      } else {
        throw new Error(`Unknown platform: ${params.platform}`);
      }

      url = `${urlForBranch}/${params.platform}/${params.branch}/${path}?game=${
        params.name
      }&token=${token}&demo=${+params.demo}&lang=${
        params.lang
      }&hideFullScreenHand=${
        params.hideFullScreenHand
      }&cashierURL=${encodeCashierURL}&homeURL=${encodeHomeURL}&device=${
        vbDevice === "web" ? "web" : params.device
      }&serviceName=${params.serviceName}&baseUrl=${encodeURIComponent(
        params.baseUrl
      )}&certification=${params.certification}&providerId=${
        params.providerId
      }&providerOperatorId=${params.providerOperatorId}`;
    } else {
      url = `${config.game_url}?game=${
        params.name
      }&token=${token}&demo=${+params.demo}&lang=${
        params.lang
      }&hideFullScreenHand=${
        params.hideFullScreenHand
      }&cashierURL=${encodeCashierURL}&homeURL=${encodeHomeURL}&device=${
        params.device
      }`;
    }

    setGameURL(url);
    if (configIframe.iFrameMode) {
      showModal();
    } else {
      gameParams.newWindow ? window.open(url, '_blank') : window.location.href = url;
    }
  };

  return (
    <div className="launcher">
      <h1 className="title">Game Launcher</h1>
      <form onSubmit={handleSubmit}>
        <FormLauncher
          urlForBranch={urlForBranch}
          setUrlForBranch={setUrlForBranch}
          isBranchTest={isBranchTest}
          setBranchTest={setBranchTest}
          isProviderTest={isProviderTest}
          setProviderTest={setProviderTest}
          params={params}
          setParams={setParams}
          slotGamesSorted={slotGamesSorted}
          videoBingoGamesSorted={videoBingoGamesSorted}
          providerInputData={providerInputData}
          setProviderInputData={setProviderInputData}
          operatorUrl={operatorUrl}
          setOperatorUrl={setOperatorUrl}
          ishomeURLValid={ishomeURLValid}
          iscashierURLValid={iscashierURLValid}
          setIshomeURLValid={setIshomeURLValid}
          setIscashierURLValid={setIscashierURLValid}
        />
        <div className="btn-container">
          <button className="btn" type="submit">
            Launch
          </button>
        </div>
   
      </form>
      <HomeButton />
      {isShowModal && (
        <IframeModal
          show={isShowModal}
          onClose={hideModal}
          gameURL={gameURL}
          iFrameReload={configIframe.iFrameReload}
          iFrameCompatibility={iFrameCompatibility}
        />
      )}
    </div>
  );
}
